import React, { useCallback, useEffect, useMemo } from "react";

import { useSelector, useDispatch } from "react-redux";

import { useIntl } from "react-intl";

import { getProfileServiceProvider } from "../../../redux/modules/profile/actions";

import useNotification from "../../../hooks/newUXNotification";

import Button from "../../../newUXComponents/Button";
import Edit from "../../../newUXAssets/icons/Edit";

import taxes from "../../../constants/taxes";

import {
  Container,
  Content,
  Information,
  Label,
  Description,
  BtnEdit,
} from "./styles";

const ViewInformation = ({ onClickEdit }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const notification = useNotification();

  const { serviceProvider } = useSelector((state) => state.profile);


  const taxesOptions = taxes;

  const userType = useMemo(() => {
    if (serviceProvider?.accountType === "J") {
      return intl.formatMessage({ id: "legal_entity" });
    }

    if (serviceProvider?.accountType === "F") {
      return intl.formatMessage({ id: "natural_person" });
    }

    if (serviceProvider?.accountType === "I") {
      return intl.formatMessage({
        id: "international",
      });
    }

    return " - ";
  }, [serviceProvider, intl]);

  const filterProvisionTypes = useMemo(() => {
    if (!serviceProvider.typesListNames?.length)
      return [
        {
          label: " - ",
        },
      ];

    return serviceProvider.typesListNames.map((name) => ({
      label: name,
    }));
  }, [serviceProvider]);

  const labelTaxes = useMemo(() => {
    if (!serviceProvider.taxes) return " - ";
    return taxesOptions.find((item) => item.value === serviceProvider.taxes).label;
  }, [taxesOptions, serviceProvider]);

  const callBackError = useCallback(
    (message) => {
      notification.displayError(
        intl.formatMessage({
          id: "api.error." + message,
        }),
        "get-service-provider-error"
      );
    },
    [notification, intl]
  );

  useEffect(() => {
    dispatch(getProfileServiceProvider(callBackError));
  }, []);

  return (
    <>
      <Container>
        <Content>
          <Information>
            <Label>{intl.formatMessage({ id: "type" })}</Label>
            <Description>{userType}</Description>
          </Information>
          <Information>
            <Label>{intl.formatMessage({ id: "types_of_service" })}</Label>
            <Description>
              {filterProvisionTypes.length &&
                filterProvisionTypes.map((item, index) => {
                  if (index + 1 < filterProvisionTypes.length) {
                    return item.label + ", ";
                  }
                  return item.label;
                })}
            </Description>
          </Information>
        </Content>
        <Content>
          <Information>
            <Label>{intl.formatMessage({ id: "name_last_name" })}</Label>
            <Description>
              {serviceProvider.nameLastName || " - "}
            </Description>
          </Information>
          <Information>
            <Label>{intl.formatMessage({ id: "zip_code" })}</Label>
            <Description>
              {serviceProvider.accountAddress?.zipCode || " - "}
            </Description>
          </Information>
        </Content>

        <Content>
          <Information>
            <Label>{intl.formatMessage({ id: "trade_name" })}</Label>
            <Description>
              {serviceProvider.name || " - "}
            </Description>
          </Information>
          <Information>
            <Label>{intl.formatMessage({ id: "address" })}</Label>
            <Description>
              {serviceProvider.accountAddress?.avenue || " - "}
            </Description>
          </Information>
        </Content>

        <Content>
          <Information>
            <Label>{intl.formatMessage({ id: "corporate_name" })}</Label>
            <Description>
              {serviceProvider.companyName || " - "}
            </Description>
          </Information>
          <Information>
            <Label>{intl.formatMessage({ id: "address_number" })}</Label>
            <Description>
              {serviceProvider.accountAddress?.number || " - "}
            </Description>
          </Information>
        </Content>

        <Content>
          <Information>
            <Label>
              {intl.formatMessage({ id: "id_number_cnpj_passport" })}
            </Label>
            <Description>
              {serviceProvider.document || " - "}
            </Description>
          </Information>
          <Information>
            <Label>{intl.formatMessage({ id: "district" })}</Label>
            <Description>
              {serviceProvider.accountAddress?.district || " - "}
            </Description>
          </Information>
        </Content>

        <Content>
          <Information>
            <Label>{intl.formatMessage({ id: "state_inscription" })}</Label>
            <Description>
              {serviceProvider.stateInscription || " - "}
            </Description>
          </Information>
          <Information>
            <Label>{intl.formatMessage({ id: "city" })}</Label>
            <Description>
              {serviceProvider.accountAddress?.city || " - "}
            </Description>
          </Information>
        </Content>

        <Content>
          <Information>
            <Label>{intl.formatMessage({ id: "city_inscription" })}</Label>
            <Description>
              {serviceProvider.municipalInscription || " - "}
            </Description>
          </Information>
          <Information>
            <Label>{intl.formatMessage({ id: "state" })}</Label>
            <Description>
              {serviceProvider.accountAddress?.state || " - "}
            </Description>
          </Information>
        </Content>

        <Content>
          <Information>
            <Label>{intl.formatMessage({ id: "country" })}</Label>
            <Description>
              {serviceProvider.accountAddress?.country || " - "}
            </Description>
          </Information>
          <Information>
            <Label>{intl.formatMessage({ id: "phone" })}</Label>
            <Description>
              {serviceProvider.telephone || " - "}
            </Description>
          </Information>
        </Content>

        <Content>
          <Information>
            <Label>{intl.formatMessage({ id: "email" })}</Label>
            <Description>
              {serviceProvider.email || " - "}
            </Description>
          </Information>
          <Information>
            <Label>{intl.formatMessage({ id: "mobile" })}</Label>
            <Description>
              {serviceProvider.mobile || " - "}
            </Description>
          </Information>
        </Content>

        <Content>
          <Information>
            <Label>{intl.formatMessage({ id: "taxes" })}</Label>
            <Description>{labelTaxes}</Description>
          </Information>
          <Information>
          </Information>
        </Content>
      </Container>
      <BtnEdit>
        <Button
          onClick={() => onClickEdit()}
          label={intl.formatMessage({ id: "edit" })}
          type="primary"
          icon={<Edit />}
        />
      </BtnEdit>
    </>
  );
};

export default ViewInformation;
